export default "__VITE_PUBLIC_ASSET__d7275a73__"